var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInpayLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 29,
    viewBox: "0 0 111 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.18 8.04V22H39.38V8.04H42.18ZM51.0864 10.76C52.4064 10.76 53.4731 11.18 54.2864 12.02C55.0997 12.8467 55.5064 14.0067 55.5064 15.5V22H52.7064V15.88C52.7064 15 52.4864 14.3267 52.0464 13.86C51.6064 13.38 51.0064 13.14 50.2464 13.14C49.4731 13.14 48.8597 13.38 48.4064 13.86C47.9664 14.3267 47.7464 15 47.7464 15.88V22H44.9464V10.92H47.7464V12.3C48.1197 11.82 48.5931 11.4467 49.1664 11.18C49.7531 10.9 50.3931 10.76 51.0864 10.76ZM68.3491 12.36C68.3491 13.1067 68.1691 13.8067 67.8091 14.46C67.4624 15.1133 66.9091 15.64 66.1491 16.04C65.4024 16.44 64.4557 16.64 63.3091 16.64H60.9691V22H58.1691V8.04H63.3091C64.3891 8.04 65.3091 8.22667 66.0691 8.6C66.8291 8.97333 67.3957 9.48667 67.7691 10.14C68.1557 10.7933 68.3491 11.5333 68.3491 12.36ZM63.1891 14.38C63.9624 14.38 64.5357 14.2067 64.9091 13.86C65.2824 13.5 65.4691 13 65.4691 12.36C65.4691 11 64.7091 10.32 63.1891 10.32H60.9691V14.38H63.1891ZM69.617 16.42C69.617 15.3 69.837 14.3067 70.277 13.44C70.7304 12.5733 71.337 11.9067 72.097 11.44C72.8704 10.9733 73.7304 10.74 74.677 10.74C75.5037 10.74 76.2237 10.9067 76.837 11.24C77.4637 11.5733 77.9637 11.9933 78.337 12.5V10.92H81.157V22H78.337V20.38C77.977 20.9 77.477 21.3333 76.837 21.68C76.2104 22.0133 75.4837 22.18 74.657 22.18C73.7237 22.18 72.8704 21.94 72.097 21.46C71.337 20.98 70.7304 20.3067 70.277 19.44C69.837 18.56 69.617 17.5533 69.617 16.42ZM78.337 16.46C78.337 15.78 78.2037 15.2 77.937 14.72C77.6704 14.2267 77.3104 13.8533 76.857 13.6C76.4037 13.3333 75.917 13.2 75.397 13.2C74.877 13.2 74.397 13.3267 73.957 13.58C73.517 13.8333 73.157 14.2067 72.877 14.7C72.6104 15.18 72.477 15.7533 72.477 16.42C72.477 17.0867 72.6104 17.6733 72.877 18.18C73.157 18.6733 73.517 19.0533 73.957 19.32C74.4104 19.5867 74.8904 19.72 75.397 19.72C75.917 19.72 76.4037 19.5933 76.857 19.34C77.3104 19.0733 77.6704 18.7 77.937 18.22C78.2037 17.7267 78.337 17.14 78.337 16.46ZM94.4917 10.92L87.6317 27.24H84.6517L87.0517 21.72L82.6117 10.92H85.7517L88.6117 18.66L91.5117 10.92H94.4917Z",
    fill: "#44444F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 3,
    width: 24,
    height: 24,
    rx: 8,
    stroke: "#0073FF",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 4,
    width: 12,
    height: 12,
    rx: 6,
    stroke: "#0073FF",
    strokeWidth: 4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 111,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInpayLogo);
export default __webpack_public_path__ + "static/media/inpayLogo.c319e7b8aeb717eca955f28d7d64ce53.svg";
export { ForwardRef as ReactComponent };